import NearMissCategoryList from "./components/NearMissCategoryList";

export default NearMissCategoryList